export enum UserRole {
  STUDENT = 'student',
  INSTRUCTOR = 'instructor',
}

export enum AdminRole {
  INSTRUCTOR = 'instructor',
  TECH_DIRECTOR = 'tech_director',
  PRINCIPAL = 'principal',
}
